import { useEffect, useRef, useState } from "react";
import { Alert, Button, Card, Space, Spin, Typography } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthContext";
import { ApiError } from "../api/client";
import { finishSso, SsoError } from "../auth/sso";
import { palette } from "../theme";
import { BrandBlock } from "./LoginPage";

export default function SsoCallbackPage() {
  const { t } = useTranslation();
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [err, setErr] = useState<string | null>(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return; // StrictMode: il codice si puo' scambiare una volta sola
    started.current = true;
    finishSso(new URLSearchParams(window.location.search))
      .then(async (to) => {
        await refresh();
        nav(to, { replace: true });
      })
      .catch((e: unknown) => {
        if (e instanceof ApiError) setErr(e.message);
        else if (e instanceof SsoError) setErr(`${t("c_ssoFailed")} (${e.message})`);
        else setErr(t("c_ssoFailed"));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: palette.bg, padding: 16 }}>
      <Card style={{ width: "100%", maxWidth: 440 }}>
        <Space direction="vertical" size={20} style={{ width: "100%" }}>
          <BrandBlock />
          {err ? (
            <>
              <Alert type="error" showIcon message={t("c_ssoErrTitle")} description={err} />
              <Link to="/login">
                <Button type="primary" block>
                  {t("c_backLogin")}
                </Button>
              </Link>
            </>
          ) : (
            <div style={{ textAlign: "center", padding: 12 }}>
              <Spin />
              <Typography.Paragraph type="secondary" style={{ marginTop: 12, marginBottom: 0 }}>
                {t("c_ssoWait")}
              </Typography.Paragraph>
            </div>
          )}
        </Space>
      </Card>
    </div>
  );
}
